<template>
    <audio controls class="embed-file-audio w-full">
        <source v-bind:src="file.url" :type="'audio/' + file.extension">
    </audio>
</template>

<script>

export default {
    name: 'EmbedFileAudio',
    props: ['file']
};
</script>
